// LocalStorageService.js
import VueJwtDecode from 'vue-jwt-decode'

const LocalStorageService = (function () {
    let _service;

    function _setAreaPredeterminada(id) {
        localStorage.setItem("xvictrl", id);
    }

    function _getAreaPredeterminada() {
        return localStorage.getItem("xvictrl");
    }

    function _destroy() {
        sessionStorage.clear();
    }

    function _start(token, tokenRefresh) {
        sessionStorage.clear();
        sessionStorage.setItem("sesion_init", Date());
        sessionStorage.setItem("vue-session-key", token);
        sessionStorage.setItem("vue-session-refresh-key", tokenRefresh);
    }

    function _isAuth() {
        const tokenValor = obtenerValorToken();
        return tokenValor != null;
    }

    function _getService() {
        if (!_service) {
            _service = this;
            return _service
        }
        return _service
    }

    function _getAccessToken() {
        const sesionK = sessionStorage.getItem("vue-session-key");
        if (sesionK !== undefined && sesionK !== null) {
            return sesionK;
        }
        return null;
    }
    function _getRefreshAccessToken() {
        const sesionK = sessionStorage.getItem("vue-session-refresh-key");
        if (sesionK !== undefined && sesionK !== null) {
            return JSON.parse(sesionK).refresh;
        }
        return null;
    }

    function obtenerValorToken() {
        if (sessionStorage == null) {
            return null;
        }

        const sesionK = sessionStorage.getItem("vue-session-key");
        if (sesionK !== undefined && sesionK !== null) {
            return VueJwtDecode.decode(sesionK);
        }
        return null;
    }

    function _can(permiso) {

        if (!_isAuth()) {
            return false;
        }

        const authorities = _getAuthorities();
        if (authorities !== null) {
            try {
                const entra = authorities.split(',').indexOf(permiso) > -1;
                // console.info("-----------entra", permiso, entra);
                return entra;
            } catch (e) {
                // console.info("-----------err entra", permiso,  authorities.split(',').indexOf(permiso));
                return false;
            }
        } else {
            // console.info("---------exepcion permisos", permiso);
            return false;
        }
    }

    function _getAuthorities() {
        return sessionStorage.getItem("vue-session-autorities");
    }

    function _setAuthorities(authorities) {
        sessionStorage.setItem("vue-session-autorities", authorities);
    }

    function _getIdUsuario() {
        return sessionStorage.getItem("vue-session-id-usuario");
    }

    function _setIdUsuario(idUsuario) {
        sessionStorage.setItem("vue-session-id-usuario", idUsuario);
    }

    function _getNombreCompleto() {
        return sessionStorage.getItem("vue-session-nombre-completo");
    }

    function _setNombreCompleto(nombreCompleto) {
        sessionStorage.setItem("vue-session-nombre-completo", nombreCompleto);
    }

    function _getUsuario() {
        return sessionStorage.getItem("vue-session-nombre-usuario");
    }

    function _setUsuario(nombreUsuario) {
        sessionStorage.setItem("vue-session-nombre-usuario", nombreUsuario);
    }

    function _getNumEmpleado() {
        return sessionStorage.getItem("vue-session-num-empleado");
    }

    function _setNumEmpleado(numEmpleado) {
        sessionStorage.setItem("vue-session-num-empleado", numEmpleado);
    }

    return {
        setAreaPredeterminada:_setAreaPredeterminada,
        getAreaPredeterminada:_getAreaPredeterminada,
        getService: _getService,
        getAccessToken: _getAccessToken,
        getRefreshAccessToken:_getRefreshAccessToken,
        getAuthorities: _getAuthorities,
        setAuthorities:_setAuthorities,
        getNumEmpleado: _getNumEmpleado,
        setNumEmpleado: _setNumEmpleado,
        getIdUsuario: _getIdUsuario,
        setIdUsuario:_setIdUsuario,
        getNombreCompleto: _getNombreCompleto,
        setNombreCompleto:_setNombreCompleto,
        getUsuario: _getUsuario,
        setUsuario:_setUsuario,
        can: _can,
        isAuth: _isAuth,
        destroy: _destroy,
        start: _start
    }
})();
export default LocalStorageService;
